import React from 'react';
import { Autocomplete, TextField } from '@mui/material';

/**
 * Composant Select avec recherche pour remplacer les composants Select standards de Material-UI
 * 
 * Props:
 * - label: Texte du label
 * - value: Valeur actuellement sélectionnée (ID ou objet)
 * - onChange: Fonction de callback (value) => {}
 * - options: Array d'objets {id, name} ou {value, label}
 * - getOptionLabel: Fonction pour obtenir le label d'une option (default: option.name || option.label)
 * - getOptionValue: Fonction pour obtenir la valeur d'une option (default: option.id || option.value)
 * - required: Si le champ est requis
 * - error: Si le champ a une erreur
 * - helperText: Texte d'aide
 * - fullWidth: Si le champ prend toute la largeur
 * - disabled: Si le champ est désactivé
 */
function SearchableSelect({
  label,
  value,
  onChange,
  options = [],
  getOptionLabel = (option) => option.name || option.label || '',
  getOptionValue = (option) => option.id || option.value || '',
  required = false,
  error = false,
  helperText = '',
  fullWidth = true,
  disabled = false,
  loading = false,
  ...otherProps
}) {
  // Trouver l'option correspondant à la valeur
  const selectedOption = value
    ? options.find(opt => getOptionValue(opt).toString() === value.toString())
    : null;

  const handleChange = (event, newValue) => {
    if (newValue) {
      onChange(getOptionValue(newValue));
    } else {
      onChange('');
    }
  };

  return (
    <Autocomplete
      fullWidth={fullWidth}
      options={options}
      value={selectedOption}
      onChange={handleChange}
      getOptionLabel={getOptionLabel}
      disabled={disabled}
      loading={loading}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          required={required}
          error={error}
          helperText={helperText}
        />
      )}
      {...otherProps}
    />
  );
}

export default SearchableSelect;

